<template>
  <div class="side-info">
    <div v-html="paramsFormulaire.graceAVotreAppui"></div>
    <ul class="equivalents-list my-3" v-if="paramsFormulaire.montantsSuggeres.length > 0">
      <li v-for="item in paramsFormulaire.montantsSuggeres" :key="item.montant">
        <div class="amount">{{item.montant }}$</div>
        <span>{{item.description}}</span>
      </li>
    </ul>
    <div v-html="paramsFormulaire.mentions"></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters({ paramsFormulaire: "getParamsFormulaire" }),
  },
};
</script>

<style lang="scss">
ul.equivalents-list {
  list-style-type: none;
  margin: 0;
  padding: 0;
  li {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #f77f79;
    padding: 10px;
  }
  li:last-of-type {
    border-bottom: none;
  }
  li .amount {
    display: block;
    min-width: 90px;
    margin-right: 10px;
    font-size: 25px;
    background-color: #e0e0e0;
    text-align: center;
    padding: 5px;
    border-radius: 4px;
  }
}
</style>